import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const refCode = localStorage.getItem("yva_ref");
    api.post("/auth/session", { session_id: sessionId, ref: refCode || null })
      .then(({ data }) => {
        localStorage.removeItem("yva_ref");
        localStorage.setItem("yva_token", data.session_token);
        setUser(data.user);
        const role = data.user?.role;
        const dest = role === "admin" || role === "sub_admin" ? "/dashboard/admin" : role === "influencer" ? "/dashboard/influencer" : role === "partner" ? "/dashboard/partner" : "/dashboard/track";
        window.history.replaceState({}, document.title, dest);
        toast.success("Signed in with Google!");
        navigate(dest, { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8F9FA] gap-6">
      <Logo />
      <Loader2 className="w-8 h-8 animate-spin text-[#0B2447]" />
      <p className="text-slate-500 text-sm">Signing you in…</p>
    </div>
  );
}
